import { IQuestion } from "../Question";
import { IDimension, ISurvey } from "../Survey";
import { DataConverter } from "./DataConverter";
import { QuestionsConverter } from "./QuestionsConverter";

export class SurveyConverterFactory {
    public createConverter(type: string, rawDataFull: any, rawDataWithR: any): SurveyConverter {
        switch (type) {
            case "enps": return new EmpsSurveyConverter(rawDataFull, rawDataWithR);
            default: return {} as SurveyConverter;
        }
    }
}

export abstract class SurveyConverter extends DataConverter {
    protected survey = {} as ISurvey;

    protected getBasicData(): void {
        this.survey.id = this.rawDataFull.id;
        this.survey.title = this.rawDataFull.title;
    }

    protected getDimensionDisplayName(dimensionName: string): string {
        switch (dimensionName) {
            case "Exhaustion":
                return "Employee Exhaustion";
            case "Disengagement":
                return "Employee Engagement";
            default:
                return dimensionName;
        }
    }

    protected getDimensionsData(): void {
        //get dimensions name
        let dimensions = [] as IDimension[];
        let originalNames: string[] = [];
        for (const page of this.rawDataFull.json.pages) {
            // Only add dimension if page.title exists and is not the survey title itself
            if (page.title && page.title !== this.rawDataFull.title) {
                originalNames.push(page.title);
                dimensions.push({ name: this.getDimensionDisplayName(page.title) } as IDimension)
            }
        }
        this.survey.dimensions = dimensions;

        const questionsConverter = new QuestionsConverter(this.rawDataFull, this.rawDataWithR);
        const questions: IQuestion[] = questionsConverter.createQuestions();
        
        // Store questions in survey for dimension calculations
        (this.survey as any).questions = questions;
        
        let i=0;
        for (const dimension of this.survey.dimensions) {
            let scoreSum = 0;
            let maxScoreSum = 0;
            let dimensionQuestions: IQuestion[] = questions.filter(question => question.dimension == originalNames[i]);
            let number = dimensionQuestions.length;
            for (const question of dimensionQuestions) {
                scoreSum += question.score;
                maxScoreSum += question.maxScore;
            }
            this.survey.dimensions[i].score = scoreSum / number;
            this.survey.dimensions[i].maxScore = maxScoreSum / number;
            i++;
        }
    }

    public createSurvey(): ISurvey {
        this.getBasicData();
        this.getDimensionsData();
        return this.survey;
    }
}

export class EmpsSurveyConverter extends SurveyConverter {

}